import { Routes } from '@angular/router';
import { userLoggedInGuard } from './guards/user-logged-in.guard';
import { activeUserGuard } from './guards/active-user.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },

  {
    path: 'login',
    canActivate: [userLoggedInGuard],
    loadComponent: () =>
      import('./features/auth/login/login.component').then(
        (m) => m.LoginComponent,
      ),
  },
  {
    path: 'form-template',
    canActivate: [activeUserGuard],
    canActivateChild: [activeUserGuard],
    loadComponent: () =>
      import('./features/forms/form-template.component').then(
        (m) => m.FormTemplateComponent,
      ),
  },
  {
    path: 'vehicles',
    canActivate: [activeUserGuard],
    canActivateChild: [activeUserGuard],
    loadComponent: () =>
      import('./features/dashboard/home/home.component').then(
        (m) => m.HomeComponent,
      ),
    children: [
      {
        path: 'list',
        loadComponent: () =>
          import('./features/dashboard/vehicles-list/vehicles-list.component').then(
            (m) => m.VehiclesListComponent,
          ),
      },
      {
        path: 'detail/:plate',
        loadComponent: () =>
          import('./features/dashboard/vehicle-detail/vehicle-detail.component').then(
            (m) => m.VehicleDetailComponent,
          ),
      },
    ],
  },

  { path: '**', redirectTo: 'login' },
];
